var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartLineIconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", {
    className: "icn me-2"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0367 2.66699C12.9934 2.88975 12.9718 3.11617 12.9722 3.34309C12.9722 5.379 14.6251 7.02943 16.664 7.02943C16.8885 7.02833 17.1124 7.00677 17.333 6.96504V14.2733C17.333 17.348 15.5194 19.167 12.4402 19.167H5.73384C2.64664 19.167 0.833008 17.348 0.833008 14.2733V7.57675C0.833008 4.50211 2.64664 2.66699 5.73384 2.66699H13.0367ZM13.0399 8.16845C12.8607 8.19423 12.6996 8.29148 12.5934 8.43797L10.3848 11.2792L7.86989 9.29919C7.72631 9.18733 7.54366 9.13794 7.36317 9.16217C7.18268 9.1864 7.01958 9.28221 6.91068 9.42797L4.20233 12.9211C4.10713 13.0398 4.05588 13.1876 4.05724 13.3397L4.05962 13.4408C4.08587 13.7067 4.2682 13.9364 4.52935 14.0188C4.82315 14.1116 5.1426 13.9945 5.30663 13.7341L7.57165 10.8043L10.0865 12.7763C10.2296 12.8916 10.4134 12.9439 10.5959 12.9211C10.7783 12.8983 10.9436 12.8025 11.0538 12.6555L13.6735 9.27504V9.25894C13.8978 8.95759 13.8406 8.53264 13.5445 8.30114C13.4013 8.19054 13.2192 8.14266 13.0399 8.16845Z",
    fill: "#3A674A",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.8747 5.41683C18.1403 5.41683 19.1663 4.39082 19.1663 3.12516C19.1663 1.85951 18.1403 0.833496 16.8747 0.833496C15.609 0.833496 14.583 1.85951 14.583 3.12516C14.583 4.39082 15.609 5.41683 16.8747 5.41683Z",
    fill: "#3A674A",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLineIconLight);
export default __webpack_public_path__ + "static/media/chart-line-icon-light.de2fe9b80df85db3ad8e83e3a6d39585.svg";
export { ForwardRef as ReactComponent };